import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SyncFusion_Main.html?raw';
import on from 'dojo/on';
import MainProperties from '../../WebCalendar_TS/MainProperties/MainPropertiesV2';
import "../../WebCalendar_TS/MainProperties/MainProperties";
import { ToasterHelpers } from "../../../more/Helpers";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";

class SyncFusion_Main extends compose(_WidgetBaseSP) {
    templateString: any = template;

    protected mainProperties: MdsLax<InstanceType<typeof MainProperties>>;

    //evBookingEditorSectionsConfig: EvBookingEditor_SectionsConfig = {
    //    isBookerSectionVisible: false,
    //    isTicketSectionVisible: true,
    //    isCastListVisible: true,
    //    isProgramListVisible: true,
    //    isEvTasksListVisible: true,
    //    isServiceListVisible: true,
    //    isOrchesterEmployementsListVisible: true,
    //    isEvCategoriesListVisible: true,
    //    isFilesSectionVisible: true
    //}

    protected _onCalendarCreated() {

    }


    protected _onClick_CalendarCell(data: WebcalendarTypes.CellClickData_Simple) {

    }

    showItemDetails(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        let selectedCalendar = this.mainProperties.getCurrentSelectedCalendar();
        let calendarID = "";
        if (selectedCalendar) {
            calendarID = selectedCalendar.ID;
        }

        let additionalData = {
            selectedHtCalendarID: calendarID
        };

        if (false) {
        // hier spezielle Programmierung...
        } else {
            this.mainProperties.openDefaultDetailView(item);
        }

    }


    protected _setupMainPropertes(): void{

        if (this.mainProperties != null) {
            this.mainProperties.destroy();
            this.mainProperties = null;
        }

        this.mainProperties = new MainProperties();

        on(this.mainProperties, "calendarCreated", lang.hitch(this, this._onCalendarCreated));
        on(this.mainProperties, "calendarCellClicked", lang.hitch(this, this._onClick_CalendarCell));

        this.UiModder.domConstruct.place(this.mainProperties.domNode, this.domNode, "first");

        let detailFct = lang.hitch(this, this.showItemDetails);

        this.mainProperties.setMainConfig({
            itemDetails: {
                customItemClickFunction: detailFct,
            }
        });

        this.mainProperties.startup();

        this._preparePanels();

        // Titel überschreiben, der vom Webkalender gesetzt würde
        //this.mainProperties.setTitles(
        //    this.stringFormat(this.translations["KWittCalendar__MainTitle"], this.translations["MainTitle"]),
        //    this.translations["KWittCalender__Title"]);

    }


    protected _preparePanels(): void {
        if (!this.mainProperties) {
            return;
        }

        let props = this.mainProperties;

        //props.addCustomPane(....)

    }

    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.none, timeout?: number, extendedMessage?: string): void {
        if (!this.mainProperties) {
            alert(text);
            console.error(text, extendedMessage);
            return;
        }
        this.mainProperties.publishToastMessage(text, icon, timeout, extendedMessage)
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        //this._isStartup = true;
        //this._continueWithSession();
        //this._checkUrlParameters();
        this._setupMainPropertes();
    }

}

export default mdsWidget(SyncFusion_Main);
